ChildMixin = require 'mixins/map-child'
InvokeActionMixin = require 'mixins/invoke-action'

module.exports = App.BaseLayerComponent = Ember.Component.extend ChildMixin, InvokeActionMixin,
  tagName: ''
  L: L

  concatenatedProperties: [
    'leafletOptions'
    'leafletRequiredOptions'
    'leafletEvents'
    'leafletProperties'
  ]

  createLayer: ->
    Ember.assert 'BaseLayer\'s `createLayer` should be overriden.'
    return

  didCreateLayer: Ember.K
  willDestroyLayer: Ember.K

  layerSetup: ->
    @_layer = @createLayer()
    @_addObservers()
    @_addEventListeners()
    if @get('containerLayer')
      @get('containerLayer')._layer.addLayer @_layer
    @didCreateLayer()
    return

  layerTeardown: ->
    @willDestroyLayer()
    @_removeEventListeners()
    @_removeObservers()
    if @get('containerLayer') and @_layer
      @get('containerLayer')._layer.removeLayer @_layer
    @_layer = null
    return

  leafletOptions: []
  options: Ember.computed(->
    leafletOptions = @get('leafletOptions')
    options = {}
    self = this
    leafletOptions.forEach (optionName) ->
      if self.get(optionName) != undefined
        options[optionName] = self.get(optionName)
    options
  )

  leafletRequiredOptions: []
  requiredOptions: Ember.computed(->
    leafletRequiredOptions = @get('leafletRequiredOptions')
    options = []
    self = this
    leafletRequiredOptions.forEach (optionName) ->
      #Ember.assert(`\`${optionName}\` is a required option but its value was \`${this.get(optionName)}\``, this.get(optionName));
      options.push self.get(optionName)
      return
    options
  )

  leafletEvents: Ember.A()
  usedLeafletEvents: Ember.computed('leafletEvents', ->
    self = this
    @get('leafletEvents').filter (eventName) ->
      methodName = '_' + eventName
      actionName = 'on' + Ember.String.classify(eventName)
      self.get(methodName) != undefined or self.get(actionName) != undefined
  )

  _addEventListeners: ->
    @_eventHandlers = {}
    @get('usedLeafletEvents').forEach ((eventName) ->
      actionName = 'on' + Ember.String.classify(eventName)
      methodName = '_' + eventName
      # create an event handler that runs the function inside an event loop.

      @_eventHandlers[eventName] = (e) ->
        Ember.run.schedule 'actions', this, ->
          #try to invoke/send an action for this event
          @invokeAction actionName, e
          #allow classes to add custom logic on events as well
          if typeof @[methodName] == 'function'
            Ember.run this, @[methodName], e
          return
        return

      @_layer.addEventListener eventName, @_eventHandlers[eventName], this
      return
    ), this

    return

  _removeEventListeners: ->
    @get('usedLeafletEvents').forEach ((eventName) ->
      @_layer.removeEventListener eventName, @_eventHandlers[eventName], this
      delete @_eventHandlers[eventName]
      return
    ), this
    return

  leafletProperties: []

  _addObservers: ->
    @_observers = {}
    @get('leafletProperties').forEach ((propExp) ->
      property = propExp.split(':')[0]
      leafletProperty = propExp.split(':')[1]
      if !leafletProperty
        leafletProperty = 'set' + Ember.String.classify(property)
      objectProperty = property.replace(/\.\[]/, '')
      #allow usage of .[] to observe array changes

      @_observers[property] = ->
        value = @get(objectProperty)
        Ember.assert @constructor + ' must have a ' + leafletProperty + ' function.', ! !@_layer[leafletProperty]

        if value?
          @_layer[leafletProperty].call @_layer, value
        return

      @addObserver property, this, @_observers[property]
      return
    ), this
    return

  _removeObservers: ->
    @get('leafletProperties').forEach ((propExp) ->
      property = propExp.split(':')[0]
      @removeObserver property, this, @_observers[property]
      delete @_observers[property]
      return
    ), this
    return
